import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductReveal } from './components/ProductReveal';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { WorkflowTotal } from './components/WorkflowTotal';
import { ForWhom } from './components/ForWhom';
import { CostComparison } from './components/CostComparison';
import { PricingSection } from './components/PricingSection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
const testimonials1 = [{
  initials: 'MG',
  name: 'Mariana G.',
  location: 'México DF',
  quote: 'Llevaba semanas intentando que ChatGPT me diera resultados útiles. Con el sistema del Tomo 1 lo logré en una tarde. El método de prompts cambió todo.'
}, {
  initials: 'LP',
  name: 'Luis P.',
  location: 'Bogotá · Agencia de Marketing',
  quote: 'Los prompts del Bono 1 me ahorraron horas cada semana. Los uso para correos, reportes y contenido. Increíble lo que se logra con el prompt correcto.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Buenos Aires',
  quote: 'Mis clientes ahora me preguntan cómo produzco tanto contenido tan rápido. La respuesta está en el Tomo 3 y el Bono 3. Vale cada centavo.'
}];
const testimonials2 = [{
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Medellín',
  quote: 'El Workflow de Ventas me cambió el negocio. Antes tardaba 2 horas en armar una propuesta. Ahora la tengo en 20 minutos y mis clientes dicen que es la más profesional que recibieron.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Buenos Aires · Emprendedor Digital',
  quote: 'Con el sistema de contenido del Tomo 3 y el Bono 3 pasé de publicar 1 vez por semana a publicar todos los días. Mi comunidad creció 300% en 60 días.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'Ciudad de México · Freelancer',
  quote: 'Mis clientes no saben que uso IA. Solo saben que entrego más rápido, con mejor calidad y que nunca me trabo en un correo difícil. El Bono 1 es oro puro.'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  location: 'Santiago de Chile · Consultor',
  quote: 'Entendí que no tenía que elegir entre las IAs. Tenía que usarlas juntas. El Workflow Total me mostró exactamente cómo. Antes del pack estaba eligiendo mal todo el tiempo.'
}];
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2002099947325430');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2002099947325430&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-dark text-white selection:bg-cyan-500/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBar data-id="element-4" />
        <Testimonials title="LO QUE DICEN QUIENES YA LO TIENEN" testimonials={testimonials1} data-id="element-5" />
        <PainPoints data-id="element-6" />
        <ProductReveal data-id="element-7" />
        <Tomos data-id="element-8" />
        <Bonuses data-id="element-9" />
        <WorkflowTotal data-id="element-10" />
        <ForWhom data-id="element-11" />
        <Testimonials title="MÁS PERSONAS QUE YA LO TIENEN" testimonials={testimonials2} data-id="element-12" />
        <CostComparison data-id="element-13" />
        <PricingSection data-id="element-14" />
        <FAQ data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}